import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import WarehouseService from "../services/WarehouseService";

export const WarehouseContext = createContext("WarehouseContext");

const WarehouseContextProvider = ({ children }) => {
	const [warehouseList, setWarehouseList] = useState([]);
	const [loadingWarehouseList, setLoadingWarehouseList] = useState(false);
	const [warehouseListErrorMsg, setWarehouseListErrorMsg] = useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getWarehouseList = async (params) => {
		setLoadingWarehouseList(true);
		setWarehouseListErrorMsg("");
		try {
			const response = await WarehouseService.getWarehouseList(params);
			setWarehouseList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setWarehouseListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingWarehouseList(false);
		}
	};

	const getWarehouseListToSendStock = async () => {
		setLoadingWarehouseList(true);
		setWarehouseListErrorMsg("");
		try {
			const response =
				await WarehouseService.getWarehouseListToSendStock();
			setWarehouseList(response.data);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setWarehouseListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingWarehouseList(false);
		}
	};

	return (
		<WarehouseContext.Provider
			value={{
				getWarehouseList,
				getWarehouseListToSendStock,
				warehouseList,
				totalElements,
				loadingWarehouseList,
				warehouseListErrorMsg,
			}}
		>
			{children}
		</WarehouseContext.Provider>
	);
};

export default WarehouseContextProvider;
